import { Button, ButtonProps } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Loader2 } from 'lucide-react';
import { FC } from 'react';

type Props = {
    tooltipText?: string;
    icon?: React.ReactElement;
    isLoading?: boolean;
} & ButtonProps;

const EButton: FC<Props> = ({
    tooltipText,
    icon,
    isLoading,
    disabled,
    children,
    ...buttonProps
}) => {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button disabled={disabled || isLoading} {...buttonProps}>
                        {isLoading ? (
                            <Loader2 className="h-5 w-5 stroke-popover-600 animate-spin" />
                        ) : (
                            icon && icon
                        )}
                        {children}
                    </Button>
                </TooltipTrigger>
                {disabled && tooltipText && <TooltipContent>{tooltipText}</TooltipContent>}
            </Tooltip>
        </TooltipProvider>
    );
};

export default EButton;
